import React from 'react';
import PropTypes from 'prop-types';
import { withRouter } from 'react-router';
import SmoothScroll from 'smooth-scroll';

const scroll = new SmoothScroll();

class ScrollToTop extends React.Component {
  componentDidUpdate(prevProps) {
    if (this.props.location !== prevProps.location) {
      scroll.animateScroll(0);
    }
  }

  render() {
    return null;
  }
}

ScrollToTop.propTypes = {
  location: PropTypes.string
};

export default withRouter(ScrollToTop);

export {
  scroll
};
